const nextUntil = function (elem, selector, filter) {

  // Setup siblings array
  var siblings = [];

  // Get the next sibling element
  elem = elem.nextElementSibling;

  // As long as a sibling exists
  while (elem) {

    // If we've reached our match, bail
    if (elem.matches(selector)) break;

    // If filtering by a selector, check if the sibling matches
    if (filter && !elem.matches(filter)) {
      elem = elem.nextElementSibling;
      continue;
    }

    // Otherwise, push it to the siblings array
    siblings.push(elem);

    // Get the next sibling element
    elem = elem.nextElementSibling;

  }

  return siblings;

};

// TODO: make it only on course collection pages
const accordionHeaders = function () {
  (function accordionDescription() {
    var nodeList = document.querySelectorAll(".js-accordion-headers h2");
    var headers = [].slice.call(nodeList).reverse();
    if (headers.length) {
      var jsAccordion = document.createElement('div');
      jsAccordion.classList.add('js-accordion');
      document.querySelector('.js-accordion-headers').append(jsAccordion);
      headers.forEach(function (header, index) {
        var tabName = header.textContent;
        var tabContent = "";
        if (tabName.length) {
          header.style.display = "none";
          var next = nextUntil(header, 'h2');
          next.forEach(function (content, index) {
            tabContent += content.outerHTML;
            content.style.display = "none";
          });

          var accordionItem = document.createElement('div');
          var accordionItemWrap = document.createElement('div');
          accordionItemWrap.classList.add('product-single__accordion__item-wrap', 'rte');
          accordionItem.classList.add('product-single__accordion__item', 'js-unique-info');
          accordionItem.id = 'acc-unique-' + index;
          accordionItem.style.display = "none";
          accordionItem.prepend(accordionItemWrap);
          document.querySelector(".js-accordion-headers .js-accordion").prepend(accordionItem);
          accordionItemWrap.innerHTML += tabContent;

          var accordionTitle = document.createElement('a');
          var accordionTitleText = document.createElement('h2');
          accordionTitle.classList.add('product-single__accordion__title', 'js-unique-trigger');
          accordionTitle.href = '#acc-unique-' + index;
          accordionTitleText.classList.add('product-single__accordion__title-text');
          accordionTitle.prepend(accordionTitleText);
          accordionTitleText.innerHTML = tabName + " <span class='icon icon-plus' aria-hidden='true'></span>";
          document.querySelector(".js-accordion-headers .js-accordion").prepend(accordionTitle);
        }
      });
      document.querySelector(".js-accordion-headers .js-accordion").style.display = 'block';
    }

    document.querySelectorAll('.js-unique-trigger').forEach(function (trigger, index) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var thisItem = trigger.hash;
        var activeClass = 'js-active';
        var thisItemEl = document.querySelector(thisItem);

        if (trigger.classList.contains(activeClass)) {
          trigger.classList.remove(activeClass);
          trigger.querySelector('.icon').classList.add('icon-plus');
          trigger.querySelector('.icon').classList.remove('icon-minus');
          thisItemEl.style.display = "none";
        } else {
          trigger.classList.add(activeClass);
          trigger.querySelector('.icon').classList.add('icon-minus');
          trigger.querySelector('.icon').classList.remove('icon-plus');
          thisItemEl.style.display = "block";
        }
        return false;
      });
    });
  })();
}

var modal = function () {

  /**
  * Element.closest() polyfill
  * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
  */
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }


  // Trap Focus 
  // https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
  //
  function trapFocus(element) {
    var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    element.addEventListener('keydown', function (e) {
      var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  }


  //
  // Settings
  //
  var settings = {
    speedOpen: 50,
    speedClose: 250,
    activeClass: 'is-active',
    visibleClass: 'is-visible',
    selectorTarget: '[data-modal-target]',
    selectorTrigger: '[data-modal-trigger]',
    selectorClose: '[data-modal-close]',
  };

  //
  // Methods
  //

  // Toggle accessibility
  var toggleccessibility = function (event) {
    if (event.getAttribute('aria-expanded') === 'true') {
      event.setAttribute('aria-expanded', false);
    } else {
      event.setAttribute('aria-expanded', true);
    }
  };

  // Open Modal
  var openModal = function (trigger) {

    // Find target
    var target = document.getElementById(trigger.getAttribute('aria-controls'));

    // Make it active
    target.classList.add(settings.activeClass);

    // Make body overflow hidden so it's not scrollable
    document.documentElement.style.overflow = 'hidden';

    // Toggle accessibility
    toggleccessibility(trigger);

    // Make it visible
    setTimeout(function () {
      let center = window.pageYOffset;
      target.classList.add(settings.visibleClass);
      target.querySelector('.modal__wrapper').style.top = `${center}px`;
      trapFocus(target);
    }, settings.speedOpen);

  };

  // Close Modal
  var closeModal = function (event) {

    // Find target
    var closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');

    // Make it not visible
    closestParent.classList.remove(settings.visibleClass);

    // Remove body overflow hidden
    document.documentElement.style.overflow = '';

    // Toggle accessibility
    toggleccessibility(childrenTrigger);

    // Make it not active
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);

  };

  // Click Handler
  var clickHandler = function (event) {

    // Find elements
    var toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);

    // Open modal when the open button is clicked
    if (open) {
      openModal(open);
    }

    // Close modal when the close button (or overlay area) is clicked
    if (close) {
      closeModal(close);
    }

    // Prevent default link behavior
    if (open || close) {
      event.preventDefault();
    }

  };

  // Keydown Handler, handle Escape button
  var keydownHandler = function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      // Find all possible modals
      var modals = document.querySelectorAll(settings.selectorTarget),
        i;

      // Find active modals and close them when escape is clicked
      for (i = 0; i < modals.length; ++i) {
        if (modals[i].classList.contains(settings.activeClass)) {
          closeModal(modals[i]);
        }
      }

    }

  };
  //
  // Inits & Event Listeners
  //
  document.addEventListener('click', clickHandler, false);
  document.addEventListener('keydown', keydownHandler, false);
};

modal();
accordionHeaders();